import { SyncWalletResponse } from "@syla/shared/types/responses/SyncWalletResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function reSyncWallet(accountId: string, walletIds: string[]) {
  try {
    const result = await axios.post<SyncWalletResponse>(
      `/accounts/${accountId}/wallets/re-sync`,
      {
        ids: walletIds,
      },
    );
    return result.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
